import { createFileRoute } from '@tanstack/react-router'

import { MasterListScreen } from './-components/master-list-screen.tsx'

export const Route = createFileRoute('/merchants/master-list')({
  component: MasterListScreen
})
